export default {
  showRoutineDeleteModal: false,
}
